export const UPLOAD_TAG_SHEET_BUTTON_TOOLTIP_MESSAGE =
  'Select a single campaign that contains line items to upload a tag sheet.';
export const UPLOAD_TAG_SHEET_BUTTON_NO_PERMISSION_TOOLTIP_MESSAGE =
  'You do not have permission to create ads and creatives required for tag sheet upload.';
export const UPLOAD_TAG_SHEET_BUTTON_BUTTON_TEXT = 'Upload Tag Sheet';
